import type {
  GameTypeData,
  GameTypeRequestData,
  GameTypesResponse,
  GameTypesResponseData
} from '@library/types/gameTypes';
import type { SelectOption } from '@library/types/utils';
import { formatDate } from '@library/component-utils/dateTime';

export const transformGameTypeData = (
  response: GameTypesResponse | undefined
): Array<GameTypeData> => {
  return response?.data.map((gameType: GameTypesResponseData) => {
    return {
      createdAt: formatDate({ date: gameType.attributes.created_at }),
      description: gameType.attributes.description,
      id: gameType.id,
      name: gameType.attributes.name,
      updatedAt: formatDate({ date: gameType.attributes.updated_at })
    };
  }) as Array<GameTypeData>;
};

export const mapGameTypeDataToRequest = (
  gameTypeFormData: Partial<GameTypeData>
): GameTypeRequestData => {
  const { id, name, description } = gameTypeFormData;
  return {
    id: id || '',
    name: name || '',
    description: description || ''
  };
};

export const transformGameTypeOptions = (
  gameTypes?: Array<GameTypeData>
): Array<SelectOption> => {
  return (
    gameTypes?.map((gameType) => ({
      name: gameType.name,
      value: gameType.id,
      key: gameType.id
    })) || []
  );
};
